AngularService = App.loadClass 'core::Angular/Service'

class exports.SlackFilesService extends AngularService
    constructor: (@http, $rootScope) ->
        super

    getToken: () =>
        @http.post 'backend/admin/slack-files/get-token'

    saveToken: (token) =>
        @http.post 'backend/admin/slack-files/save-token',
            token: token

    getFiles: () =>
        @http.post 'backend/admin/slack-files/get-files'

    getUsers: () =>
        @http.post 'backend/admin/slack-files/get-users'

    deleteFile: (file) =>
        @http.post 'backend/admin/slack-files/delete-file',
            file: file
